module.exports = __webpack_public_path__ + "img/更新.fbb947b3.png";